import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectOrganizations } from '~/src/redux/user/user.selectors';
import { CounterpartyConnectStatusEnum } from '~/src/models/enums/counterparty-connect-status.enum';

export const useOrganizationsConnectStatuses = (): boolean => {
    const organizations = useSelector(selectOrganizations);
    const isOrganizationConnectStatuses = new Set([
        CounterpartyConnectStatusEnum.CONNECTED,
        CounterpartyConnectStatusEnum.DATA_VALIDATION,
        CounterpartyConnectStatusEnum.CAN_CONNECT,
    ]);

    return useMemo(
        () =>
            organizations.some(
                (organization) =>
                    organization.connectingStatus && isOrganizationConnectStatuses.has(organization.connectingStatus),
            ),
        [organizations],
    );
};
